export * from "./consent-forms.page";
export * from "./page/consent-froms-main-page";